export var TCT_MAIN = 'TCT_MAIN';
export var TCT_PHONE = 'TCT_PHONE';
export var TCT_IE = 'TCT_IE';
export var TCT_CONFIG = 'TCT_CONFIG';
export var TCT_CONFIG_CODE = 'TCT_CONFIG_CODE';
export var TCT_USERS = 'TCT_USERS';
export var TCT_USERS_INT = 'TCT_USERS_INT';
export var TCT_USERS_TAC = 'TCT_USERS_TAC';
export var TCT_USERS_GRP = 'TCT_USERS_GRP';
export var TCT_USERS_PAS = 'TCT_USERS_PAS';
export var TCT_USERS_CONF = 'TCT_USERS_CONF';
export var TCT_CALLOPTIONS = 'TCT_CALLOPTIONS';
export var TCT_PHONELIST = 'TCT_PHONELIST';
export var TCT_UNHOOK = 'TCT_UNHOOK';
export var TCT_ENCHANCE = 'TCT_ENHANCE';
export var TCT_PTT = 'TCT_PTT';
export var TCT_USER_CONF = 'TCT_USER_CONF';
export var TCT_OFF = 'TCT_OFF';
export var TCT_MUTE = 'TCT_MUTE';
export var TCT_CIPHER = 'TCT_CIPHER';
export var TCT_CHANNELS = 'TCT_CHANNELS';
export var TCT_Images = {
    phoneCall: require('../../assets/icons/tct/phone.png'),
    phoneListCall: require('../../assets/icons/tct/internal.png'),
    groupCall: require('../../assets/icons/tct/groups.png'),
    conferenceCall: require('../../assets/icons/tct/conferences.png'),
    pasCall: require('../../assets/icons/tct/pas.png'),
};
//# sourceMappingURL=Constants.js.map